// PropertyValuation.js
import React from 'react';
import styles from './PropertyValuation.module.css';
import { historyIcon } from '../../../constants/images';

const PropertyValuation = ({ template, propertyDetail }) => {

    return (
        <div className={`${styles.container} ${styles[`container_${template}`]}`}>
            <div className={styles.header}>
                <h2 className={styles.title}>Property Insight</h2>
                {propertyDetail?.valuationType === "sell" ? <h1 className={styles.value}>
                    {propertyDetail?.property?.estimatedCurrentValue?.amount}
                    <span>{propertyDetail?.result?.unit}</span>
                </h1>
                    : <h1 className={styles.value}>£{propertyDetail?.result?.unit==="gbp_per_week" ? parseInt(propertyDetail?.result?.estimate)*4 : propertyDetail?.result?.estimate}
                        <span>{(propertyDetail?.result?.unit) && (propertyDetail?.result?.unit === "gbp_per_week" ? "/ per month" : "/ per month")}</span>
                    </h1>
                }
                <button className={styles.confidence}>
                    {propertyDetail?.property?.estimatedCurrentValue?.confidence || "High"} Confidence
                </button>
            </div>
            {propertyDetail?.valuationType === "sell" && propertyDetail?.property?.transactionCount > 0
                && <div className={styles.history}>
                    <h3 className={styles.historyTitle}>
                        <img src={historyIcon} alt="History Icon" /> Sale history
                    </h3>
                    <p className={styles.address}>{propertyDetail?.property?.address?.description}, {propertyDetail?.property?.address?.postcode}</p>
                    {propertyDetail?.property?.transaction?.length > 0 && propertyDetail?.property?.transaction?.map((history, index) => (
                        <div key={index} className={styles.historyItem}>
                            <div className={styles.history_wrap}>
                                <p className={styles.soldOn}>
                                    Sold on: <span className={styles.history_date}>{history.date?.full}</span>
                                </p>
                                <p className={styles.price}>{history?.pricePaid?.amount}</p>
                            </div>
                            <p className={styles.details}>
                                <span>Property:</span> {propertyDetail?.property?.type} <span className={styles.history_seperator}>|</span> <span>Tenure:</span> {history?.tenure}
                            </p>
                        </div>
                    ))}
                </div>}
        </div>
    );
};

export default PropertyValuation;
